import React from 'react';
import { Link } from 'react-router-dom';
import { useContent } from '../hooks/useContent';

const F = "'Inter', system-ui, sans-serif";

export default function Cafe() {
  const { content, loading, error } = useContent();

  if (loading) return <div style={styles.loading}>Inhalte werden geladen...</div>;
  if (error) return <div style={styles.errorBox}>Inhalte konnten nicht geladen werden.<br /><small>{error}</small></div>;
  if (!content) return null;

  const cafe = content.cafe || {};

  return (
    <main style={styles.page}>
      <div style={styles.pageHeader}>
        <div style={styles.pageHeaderInner}>
          <span style={styles.eyebrow}>Genuss & Erholung</span>
          <h1 style={styles.heading}>{cafe.heading || 'Unser Café'}</h1>
          <p style={styles.sub}>{cafe.subheading}</p>
        </div>
      </div>

      <div style={styles.inner}>

        {/* Foto + Intro */}
        <section style={styles.introSection}>
          {cafe.image && (
            <div style={styles.photoWrapper}>
              <img src={cafe.image} alt="Café Spirkenhof" style={styles.photo} />
            </div>
          )}
          <div style={cafe.image ? styles.introWithPhoto : styles.introFull}>
            <span style={styles.eyebrowDark}>Über uns</span>
            <h2 style={styles.sectionHeading}>Willkommen in unserer Gaststube</h2>
            {cafe.intro && <p style={styles.introText}>{cafe.intro}</p>}
            {cafe.intro2 && <p style={styles.introText}>{cafe.intro2}</p>}
            {cafe.seasonNote && (
              <div style={styles.seasonBadge}>
                <span style={styles.seasonIcon}>🗓️</span>
                {cafe.seasonNote}
              </div>
            )}
          </div>
        </section>

        {/* CTA */}
        <section style={styles.ctaSection}>
          <h2 style={styles.ctaHeading}>Planen Sie Ihren Aufenthalt?</h2>
          <p style={styles.ctaText}>Kommen Sie vorbei – wir freuen uns auf Ihren Besuch!</p>
          <div style={styles.ctaButtons}>
            <Link to="/buchung" style={styles.ctaBtn}>Jetzt anfragen</Link>
            <Link to="/galerie" style={styles.ctaBtnSecondary}>Galerie ansehen</Link>
          </div>
        </section>

      </div>
    </main>
  );
}

const styles = {
  page: { backgroundColor: 'white', minHeight: '70vh' },
  loading: { textAlign: 'center', padding: '6rem 2rem', fontFamily: F, color: '#1e8449', fontSize: '1rem' },
  errorBox: { textAlign: 'center', padding: '4rem 2rem', fontFamily: F, color: '#dc3545' },

  pageHeader: {
    backgroundColor: '#ffffff',
    borderBottom: '1px solid #e5e7eb',
    padding: '4rem 1.5rem 3.5rem',
    textAlign: 'center',
  },
  pageHeaderInner: { maxWidth: '640px', margin: '0 auto' },
  eyebrow: { fontSize: '0.75rem', fontFamily: F, fontWeight: '600', letterSpacing: '1.8px', textTransform: 'uppercase', color: '#1e8449' },
  heading: { color: '#111827', fontFamily: F, fontSize: 'clamp(1.9rem,5vw,2.8rem)', fontWeight: '800', marginTop: '0.4rem', marginBottom: '0.7rem', letterSpacing: '-0.5px' },
  sub: { color: '#6b7280', fontFamily: F, fontSize: '1.05rem', lineHeight: '1.6' },

  inner: { maxWidth: '1000px', margin: '0 auto', padding: '3.5rem 1.5rem 5rem' },

  introSection: { display: 'flex', gap: '3.5rem', alignItems: 'center', marginBottom: '4rem', flexWrap: 'wrap' },
  photoWrapper: { flex: '0 0 420px', borderRadius: '16px', overflow: 'hidden', boxShadow: '0 8px 32px rgba(0,0,0,0.10)' },
  photo: { width: '100%', height: '320px', objectFit: 'cover', display: 'block' },
  introWithPhoto: { flex: '1 1 260px' },
  introFull: { flex: 1 },

  eyebrowDark: { fontSize: '0.75rem', fontFamily: F, fontWeight: '600', letterSpacing: '1.8px', textTransform: 'uppercase', color: '#1e8449' },
  sectionHeading: { color: '#111827', fontFamily: F, fontSize: 'clamp(1.4rem,3vw,1.9rem)', fontWeight: '700', marginTop: '0.4rem', marginBottom: '1rem', letterSpacing: '-0.3px' },
  introText: { color: '#4b5563', fontFamily: F, fontSize: '0.97rem', lineHeight: '1.8', marginBottom: '0.9rem' },

  seasonBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.5rem',
    marginTop: '0.5rem',
    backgroundColor: '#f0fdf4',
    color: '#15803d',
    padding: '0.45rem 1rem',
    borderRadius: '20px',
    fontFamily: F,
    fontSize: '0.85rem',
    fontWeight: '600',
    border: '1px solid #bbf7d0',
  },
  seasonIcon: { fontSize: '0.9rem' },

  ctaSection: {
    backgroundColor: '#f8f9fa',
    borderRadius: '20px',
    padding: '3.5rem 2rem',
    textAlign: 'center',
  },
  ctaHeading: { color: '#111827', fontFamily: F, fontSize: '1.6rem', fontWeight: '700', marginBottom: '0.6rem', letterSpacing: '-0.3px' },
  ctaText: { color: '#6b7280', fontFamily: F, fontSize: '1rem', marginBottom: '2rem' },
  ctaButtons: { display: 'flex', gap: '0.85rem', justifyContent: 'center', flexWrap: 'wrap' },
  ctaBtn: { display: 'inline-block', backgroundColor: '#1e8449', color: 'white', textDecoration: 'none', padding: '0.9rem 2rem', borderRadius: '10px', fontWeight: '600', fontFamily: F, fontSize: '0.95rem', boxShadow: '0 2px 8px rgba(30,132,73,0.25)' },
  ctaBtnSecondary: { display: 'inline-block', backgroundColor: 'white', color: '#374151', textDecoration: 'none', padding: '0.88rem 2rem', borderRadius: '10px', fontWeight: '500', fontFamily: F, fontSize: '0.95rem', border: '1.5px solid #e5e7eb' },
};
